<template>
  <main>
    <fade-in-top-title class="title-interval">
      <h3>GoogleMap</h3>
      <span>Vue.js</span>
    </fade-in-top-title>
    <div class="container container-work">
      <work-contents-top>
        <div class="map" ref="googleMap" />
      </work-contents-top>
      <work-contents-text-me
      webSiteText="vue.jsでライブラリを使用せずに制作した「GoogleMap」です。"
      webSiteTextContentsFirst="サイトを開いたら、特定の住所にピンを指すようになっております。"
      webSiteTextContentsSecound="また、ピンを指した箇所は、ローカルストレージに保持されます。"/>
    </div>
    <router-link to="/work/workContents03">
      <work-slide-left></work-slide-left>
    </router-link>
    <router-link to="/work/workContents05">
      <work-slide-right></work-slide-right>
    </router-link>
  </main>
</template>

<script>
import FadeInTopTitle from '@/components/FadeInTopTitle.vue';
import WorkContentsTop from '@/components/WorkContentsTop.vue';
import GoogleMapsApiLoader from 'google-maps-api-loader';
import WorkContentsTextMe from '@/components/WorkContentsTextMe.vue';
import WorkSlideLeft from '@/components/WorkSlideLeft.vue';
import WorkSlideRight from '@/components/WorkSlideRight.vue';

export default {
  name: 'Map',
  data() {
    return {
      google: null,
      mapConfig: {
        center: {
          lat: 35.702232,
          lng: 139.985330
        },
        zoom: 10
      },
      markers: [],
      markerData: [
      {lat: 35.702232,lng: 139.985330, id:1, title: '船橋駅'},
      {lat: 35.706298,lng: 139.98156, id:2, title: '東海神駅'},
      {lat: 35.70015,lng: 139.985489, id:3, title: '京成船橋駅'},
      {lat: 35.707469,lng: 139.958967, id:4, title: '西船橋駅'},
      {lat: 35.704171,lng: 139.983013, id:5, title: '船橋北口郵便局'},
      {lat: 35.681236,lng: 139.767125, id:6, title: '東京タワー'},
      {lat: 35.661571,lng: 139.666998, id:7, title: '下北沢駅'},
      {lat: 35.729503,lng: 139.7109, id:8, title: '池袋駅'},
      {lat: 35.633913,lng: 139.715556, id:9, title: '目黒駅'},
      {lat: 35.646729,lng: 139.710103, id:10, title: '恵比寿駅'}
      ],
    }
  },
  components: {
    FadeInTopTitle,
    WorkContentsTop,
    WorkContentsTextMe,
    WorkSlideLeft,
    WorkSlideRight
  },
  async created() {
    this.google = await GoogleMapsApiLoader({
      apiKey: 'AIzaSyCQrnWiH9FgFZbmgx5YgRThnRgPc3aScgY'
    });
    this.initializeMap();
    localStorage.setItem('markerData', JSON.stringify(this.markerData)); //ローカルストレージに保存
    this.markerData2 = JSON.parse(localStorage.getItem( 'markerData' )); //ローカルストレージを取得 
  },
  methods: {
    initializeMap() {
      var map = new this.google.maps.Map(this.$refs.googleMap, this.mapConfig);

    this.markerData.forEach((coord) => { //markerDataの位置座標をループしてピンを表示
      const marker = new this.google.maps.Marker({ 
        position: {lat:coord.lat, lng:coord.lng},
        map: map
      });

      var contentString = '<div>' + coord.title + '</div>'; 

        var infoWindow = new this.google.maps.InfoWindow({ //markerDataのtitleをループ
          content: contentString,
          maxWidth: 300
        });

        marker.addListener('mouseover', function(){ //markerをmouseoverしたらinfoWindowを開く
          infoWindow.open(map, marker);
        });

        marker.addListener('mouseout', function(){//markerをmouseoutしたらinfoWindowを閉じる
          if(infoWindow)
          infoWindow.close();
        });
      });

      var trafficLayer = new this.google.maps.TrafficLayer(); //現在の交通状況をレイヤーで表示
      trafficLayer.setMap(map);

    }
  }
}
</script>

<style lang="scss" scoped>
.map {
  width: 80vw;
  height: 80vh;
}

.googleMap-wrapper {
  margin: 100px auto;
  display: flex;
  justify-content: center;
}
</style>